import JotformSvg from '../../images/jotform-icon-transparent.svg'

const JotformLogo = () => <img src={JotformSvg} alt="Jotform" style={{ height: 32 }} />

export default JotformLogo
